export enum ServerGameFeatures {
	EXPLOSION = 0,
	RESPIN = 1,
	EXPANDED_WILD = 2,
}

export class ServerData {
	public static readonly MAX_FEATURE_LEVEL: number = 5;

	private _betLevel: number = 1;
	private _coinValue: number = 1;
	private _balance: number = 10000;

	private _featuresActiveStatus: boolean[] = [false, false, false];
	private _featuresLevels: number[] = [0, 0, 0];
	private _FSFeaturesActiveStatus: boolean[] = [true, true, true];
	private _FSFeatureLevels: number[] = [5, 5, 5];
	private _priorityFeatureIndex: number;
	private _nonPriorityFeatureIndex: number;
	private _initiallyUnlockedFeatureIndex: number;

	private _totalFreeSpins: number;
	private _freeSpinsPlayed: number;
	private _isInFreeSpins: boolean = false;

	private _totalMimcFreeSpin: number;
	private _mimicFreeSpinsPlayed: number;
	private _isInMimicFreeSpins: boolean = false;

	protected makePriorityFeatures(): void {
		const activeFeatures: number = this.totalActivatedFeatures();
		if (activeFeatures <= 0 || activeFeatures > 3) {
			throw new Error('ServerData::makePriorityFeatures number of active features should be > 0 && <= 3. Currently it is ' + activeFeatures);
		}
		if (activeFeatures === 1) {
			let hasPriorityFeature: boolean = false;
			for (let i = 0; i < 3; i++) {
				if (!this._featuresActiveStatus[i]) {
					if (hasPriorityFeature) {
						this._nonPriorityFeatureIndex = i;
					} else {
						hasPriorityFeature = true;
						this._priorityFeatureIndex = i;
					}
				} else {
					this._initiallyUnlockedFeatureIndex = i;
				}
			}
		}
	}

	public totalActivatedFeatures(): number {
		let activatedFeatures: number = 0;
		for (const feature of this._featuresActiveStatus) {
			if (feature) {
				activatedFeatures++;
			}
		}

		return activatedFeatures;
	}

	public activateFeature(feature: ServerGameFeatures): void {
		this._featuresActiveStatus[feature] = true;
		this._featuresLevels[feature] = 5;
		this.makePriorityFeatures();
	}

	public makeFreeSpin(): void {
		this._freeSpinsPlayed++;
		if (this.isFreeSpinsFinished()) {
			this.finishFreeSpins();
		}
	}

	public makeMimicFreeSpin(): void {
		this._mimicFreeSpinsPlayed++;
		if (this.isMimicFreeSpinsFinished()) {
			this.finishMimicFreeSpins();
		}
	}

	public isFreeSpinsFinished(): boolean {
		return this._freeSpinsPlayed === this._totalFreeSpins;
	}

	public isMimicFreeSpinsFinished(): boolean {
		return this._mimicFreeSpinsPlayed === this._totalMimcFreeSpin;
	}

	public get isInFreeSpins(): boolean {
		return this._isInFreeSpins;
	}

	public get isInMimicFreeSpins(): boolean {
		return this._isInMimicFreeSpins;
	}

	public startFreeSpins(totalFS: number): void {
		this._freeSpinsPlayed = 0;
		this._totalFreeSpins = totalFS;
		this._isInFreeSpins = true;
	}

	public startMimicFreeSpins(totalMFS: number): void {
		this._mimicFreeSpinsPlayed = 0;
		this._totalMimcFreeSpin = totalMFS;
		this._isInMimicFreeSpins = true;
	}

	public finishFreeSpins(): void {
		this._isInFreeSpins = false;
	}

	public finishMimicFreeSpins(): void {
		this._isInMimicFreeSpins = false;
	}

	public get totalFreeSpins(): number {
		return this._totalFreeSpins;
	}

	public get freeSpinsPlayed(): number {
		return this._freeSpinsPlayed;
	}

	public get totalMimcFreeSpin(): number {
		return this._totalMimcFreeSpin;
	}

	public get mimicFreeSpinsPlayed(): number {
		return this._mimicFreeSpinsPlayed;
	}

	public addToTotalFreeSpins(freeSpinsToAdd: number): void {
		this._totalFreeSpins += freeSpinsToAdd;
	}

	public setLevelValue(feature: ServerGameFeatures, value: number): void {
		this._featuresLevels[feature] = value;
	}

	public get betLevel(): number {
		return this._betLevel;
	}

	public get coinValue(): number {
		return this._coinValue;
	}

	public get balance(): number {
		return this._balance;
	}

	public get featuresActiveStatus(): boolean[] {
		return this._featuresActiveStatus;
	}

	public get activeFeaturesNumber(): number {
		let total: number = 0;
		for (let i = 0; i < 3 ; i++) {
			if (this.featuresActiveStatus[i]) {
				total++;
			}
		}

		return total;
	}

	public get featuresLevels(): number[] {
		return this._featuresLevels;
	}

	public get priorityFeatureIndex(): number {
		return this._priorityFeatureIndex;
	}

	public set priorityFeatureIndex(value: number) {
		this._priorityFeatureIndex = value;
	}

	public get nonPriorityFeatureIndex(): number {
		return this._nonPriorityFeatureIndex;
	}

	public set nonPriorityFeatureIndex(value: number) {
		this._nonPriorityFeatureIndex = value;
	}

	public get initiallyUnlockedFeatureIndex(): number {
		return this._initiallyUnlockedFeatureIndex;
	}

	public get FSFeaturesActiveStatus(): boolean[] {
		return this._FSFeaturesActiveStatus;
	}

	public get FSFeatureLevels(): number[] {
		return this._FSFeatureLevels;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/prototype/src/data/ServerData.ts